import { styled, useTheme } from '@mui/material/styles';
import { Card, Chip, FormControl, Grid, TextField, Autocomplete } from '@mui/material';
import { MobileDateRangePicker } from '@mui/lab';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers } from '../../../../../redux/slices/hrRedux/UserManagementRedux/userManagementRedux';
import { format, startOfDay, endOfDay } from 'date-fns';
import moment from 'moment/moment';
import { accessVerify } from '../../../../../utils/common';
import { getDashboardPurchasing, getReorderStockData } from '../../../../../redux/slices/homeRedux/dashboardPurchasingRedux';

const RootStyle = styled(Card)(({ theme }) => ({}));

const DataFilter = ({ data, setData, setReorderData, setOriginalData }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  let usersListData;
  ({ data: usersListData } = useSelector((state) => state.user));
  let purchasePattern;
  let reorderStockList;
  ({ purchasePattern: purchasePattern, reorderStockList: reorderStockList } = useSelector((state) => state.dashboardPurchasing));
  const [openPicker, setOpenPicker] = useState(false);
  const [dateRange, setDateRange] = useState([startOfDay(new Date('2023-04-01 00:00:00')), endOfDay(new Date())]);
  const [selectedFood, setSelectedFood] = useState([]);
  const [filteredFoods, setFilteredFoods] = useState([]);
  let selectedLocation;
  ({ selectedLocation } = useSelector((state) => state.location));


  const isNotDeleted = (name = '') =>
    !String(name || '')
      .toLowerCase()
      .includes('delete');

  useEffect(() => {
    const startDate = moment(dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endDate = moment(dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    dispatch(
      getDashboardPurchasing({
        fromDate: startDate,
        toDate: endDate,
        locationId: selectedLocation?.id,
      })
    );
  }, [dateRange, selectedLocation]);

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  useEffect(() => {
    setReorderData(
      reorderStockList
        ?.filter((item) => isNotDeleted(item.foodName))
        .map((value) => {
          return {
            status: value?.totalStock <= value?.reorderQty ? 'Need Attention' : '',
            ...value,
          };
        })
    );
  }, [reorderStockList]);

  useEffect(() => {
    dispatch(
      getReorderStockData({
        locationId: selectedLocation?.id,
      })
    );
  }, [selectedLocation]);

  useEffect(() => {
    if (purchasePattern) {
      const uniqueFoods = Array.from(new Map(purchasePattern.filter(item => isNotDeleted(item.foodName)).map((item) => [item.foodName, item])).values());
      setFilteredFoods(uniqueFoods);
    }
  }, [purchasePattern]);

  useEffect(() => {
    if (selectedFood.length > 0) {
      setData(purchasePattern?.filter((value) => selectedFood?.includes(value.foodId)));
    } else {
      setData([]);
    }
  }, [selectedFood, purchasePattern]);

  const formatDateRangeDisplay = ([start, end]) => {
    if (!start || !end) return '';
    return `${format(start, 'dd/MM/yyyy')} - ${format(end, 'dd/MM/yyyy')}`;
  };

  return (
    <>
      {accessVerify('DASHBOARD_ANALYTICS_DATE_SELECTION') && (
        <Grid item xs={12} md={6}>
          <MobileDateRangePicker
            open={openPicker}
            onClose={() => setOpenPicker(false)}
            onOpen={() => setOpenPicker(true)}
            value={dateRange}
            onChange={(newValue) => {}}
            onAccept={(newValue) => {
              setDateRange(newValue);
            }}
            renderInput={({ inputRef, inputProps, InputProps }) => (
              <TextField
                ref={inputRef}
                {...inputProps}
                InputProps={{
                  ...InputProps,
                }}
                fullWidth
                label='Select Date Range'
                value={formatDateRangeDisplay(dateRange)}
                onClick={() => setOpenPicker(true)}
                readOnly
              />
            )}
          />
        </Grid>
      )}

      {accessVerify('DASHBOARD_ANALYTICS_FOOD_SELECTION') && (
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <Autocomplete
              multiple
              id='food-selector'
              options={filteredFoods}
              value={filteredFoods.filter((food) => selectedFood.includes(food.foodId))}
              onChange={(event, newValue) => {
                const selectedFoodIds = newValue.map((food) => food.foodId);
                setSelectedFood(selectedFoodIds);
              }}
              getOptionLabel={(option) => option.foodName}
              isOptionEqualToValue={(option, value) => option.foodId === value.foodId}
              renderInput={(params) => <TextField {...params} label='Select Food' />}
              renderOption={(props, option) => (
                <li {...props} key={`${option.foodId}-${option.foodName}`}>
                  <Chip label={option.foodName} />
                </li>
              )}
            />
          </FormControl>
        </Grid>
      )}
    </>
  );
};

export default DataFilter;
